const API = '/api/v1';

function cookie(name: string) {
  return document.cookie.split('; ').find((part) => part.startsWith(`${name}=`))?.split('=').slice(1).join('=') ?? '';
}

export class ApiFailure extends Error {
  constructor(message: string, public status: number, public details?: unknown) { super(message); }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = options.method?.toUpperCase() ?? 'GET';
  const headers = new Headers(options.headers);
  if (!(options.body instanceof FormData) && options.body !== undefined) headers.set('Content-Type', 'application/json');
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method)) headers.set('X-CSRF-Token', decodeURIComponent(cookie('pishgam_csrf')));
  const response = await fetch(`${API}${path}`, { ...options, headers, credentials: 'include' });
  if (!response.ok) { const body = await response.json().catch(() => ({})) as { message?: string; details?: unknown }; throw new ApiFailure(body.message ?? 'در ارتباط با سامانه خطایی رخ داد.', response.status, body.details); }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export function monthName(month: number) { return ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'][month - 1]; }
